import Joi from 'joi';

import { PercentageDepositRoundingModeEnum } from '../../../settings/enums/percentage-deposit-rounding-mode.enum';
import { DepositPolicyTypeEnum } from '../../enums/deposit-policy-type.enum';

/**
 * Schema for deposit policy config validation
 */
export const depositConfigSchema = () =>
  Joi.object({
    depositType: Joi.string()
      .valid(...Object.values(DepositPolicyTypeEnum))
      .required(),

    fixedAmount: Joi.number().min(0).allow(null).optional(),
    percentageOfRental: Joi.number().min(0).max(100).allow(null).optional(),
    daysWorth: Joi.number().min(0).allow(null).optional(),
    minimumDeposit: Joi.number().min(0).allow(null).optional(),
    maximumDeposit: Joi.number().min(0).allow(null).optional(),
    percentageDepositRounding: Joi.object({
      isEnabled: Joi.boolean().optional(),
      increment: Joi.number().min(0).allow(null).optional(),
      mode: Joi.string()
        .valid(...Object.values(PercentageDepositRoundingModeEnum))
        .optional(),
    })
      .unknown(false)
      .allow(null)
      .optional(),
  })
    .unknown(false)
    .custom((value, helpers) => {
      if (
        value.depositType === DepositPolicyTypeEnum.FIXED &&
        value.fixedAmount == null
      ) {
        return helpers.error('any.custom', {
          message: 'fixedAmount is required for fixed deposit policy',
        });
      }
      if (
        value.depositType === DepositPolicyTypeEnum.PERCENTAGE &&
        value.percentageOfRental == null
      ) {
        return helpers.error('any.custom', {
          message:
            'percentageOfRental is required for percentage deposit policy',
        });
      }
      if (
        value.depositType === DepositPolicyTypeEnum.DAYS_WORTH &&
        value.daysWorth == null
      ) {
        return helpers.error('any.custom', {
          message: 'daysWorth is required for days_worth deposit policy',
        });
      }
      return value;
    });
